// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"301":"494d4155","798":"cccc4324","958":"f5e48b55","967":"7bb02684","990":"ff5229f5"}[chunkId] + ".css";
};